var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.previewUrl)?_c('img',{attrs:{"src":_vm.previewUrl,"alt":_vm.$props.alt}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }